import React from 'react';

import Telephone from '../../images/Header/telephone.png';
import Logotipo from '../../images/logotipo.png';
import Pin from '../../images/Header/alfiler.png';
import './styles.scss';


class Header extends React.Component {
  render() {
    return (
      <div className="header__container">
        <div class="telephone__container">
          <a href="https://www.megacable.com.mx/">
            <img class="telephone" src={Telephone} alt="Telephone" />
          </a>
        </div>
        <div class="title__container">
          <a href="https://phone-company.netlify.app/">
            <img class="title" src={Logotipo} alt="Logotipo" />
          </a>
        </div>
        <div class="pin__container">
          <a href="https://www.megacable.com.mx/">
            <img class="pin" src={Pin} alt="Pin" />
          </a>
        </div>
      </div>
    )
  }
}

export default Header;
